import gql from 'graphql-tag';

export const UPDATE_ARTICLES_FACEBOOK_PAGE_MUTATION = gql`
  mutation UpdateArticlesFacebookPageMutation($articleIds: [ID!]!, $facebookPageId: BigInt!) {
    updateArticlesFacebookPage(articleIds: $articleIds, facebookPageId: $facebookPageId) {
      updatedArticleIds
      errors {
        articleId
        message
      }
    }
  }
`;
